/**
 * JAVASCRIPT DEVELOPER DOCUMENTATION
 *
 * Symmetry: código personalizado da loja. A documentação dos eventos do tema (on:variant:change,
 * on:cart:add, dispatch:cart-drawer:open, ...) está no custom.js original do Symmetry.
 *
 * Have fun! - The Clean Canvas Development Team.
 */

// #SACOOR# galeria da página de produto em computador: thumbnails à esquerda, fixos, e o activo segue a foto visível.
// Antes corria no window.onload (só depois de todas as imagens carregarem) e os thumbnails apareciam tarde;
// o script é defer, por isso o HTML já está todo lido quando corre.
(function() {
  var mediaGallery = document.querySelector('product-form > media-gallery');
  var carouselSlider = document.querySelector('product-form > media-gallery > div > carousel-slider');

  // só existe na página de produto; noutras páginas dava erro na consola
  if (!mediaGallery || !carouselSlider) return;

  // Add the first class to media-gallery
  mediaGallery.classList.add('media-gallery--layout-carousel-beside');

  // Add the second class to carousel-slider
  carouselSlider.classList.add('sticky-content-container');
  carouselSlider.classList.remove('mobile-only');

  // Em computador as fotos estão empilhadas (.product-media-collage); o tema não liga os thumbnails a elas
  var desktop = window.matchMedia('(min-width: 768px)');
  var thumbs = carouselSlider.querySelectorAll('.slider__item');
  var visible = new Map();

  function collageItems() {
    return mediaGallery.querySelectorAll('.product-media-collage__item');
  }

  function setActive(mediaId) {
    thumbs.forEach(function(thumb) {
      thumb.classList.toggle('is-active', thumb.dataset.mediaId === mediaId);
    });
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      visible.set(entry.target, entry.intersectionRatio);
    });
    var best = null;
    var bestRatio = 0;
    visible.forEach(function(ratio, item) {
      if (ratio > bestRatio && item.offsetParent !== null) {
        best = item;
        bestRatio = ratio;
      }
    });
    if (best && desktop.matches) setActive(best.dataset.mediaId);
  }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

  collageItems().forEach(function(item) {
    observer.observe(item);
  });

  // Clique no thumbnail: leva até essa foto (sem abrir a imagem noutra página)
  carouselSlider.addEventListener('click', function(evt) {
    if (!desktop.matches) return;
    var thumb = evt.target.closest('.slider__item');
    if (!thumb) return;
    var target = Array.prototype.find.call(collageItems(), function(item) {
      return item.dataset.mediaId === thumb.dataset.mediaId;
    });
    if (!target) return;
    evt.preventDefault();
    evt.stopPropagation();
    var offset = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'), 10) || 0) + 30;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY - offset, behavior: 'smooth' });
  }, true);
})();
// #SACOOR#

// #SACOOR# página de produto em computador: ao abrir um acordeão da info (Material, Entregas, ...) o texto aberto
// sobe até se ver inteiro, sem ter de fazer scroll. Acompanha a animação de abertura do tema fotograma a fotograma
// (o fundo do acordeão fica colado ao fundo do ecrã enquanto abre), sem esperar que acabe. Desce primeiro a página
// até a info prender e depois a própria info; nunca sobe tanto que o título do acordeão passe para baixo do header.
(function() {
  var info = document.querySelector('.detail > sticky-scroll');
  if (!info) return;
  var desktop = window.matchMedia('(min-width: 768px)');

  function reveal(details) {
    var topLimit = (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height'), 10) || 0) + 30;
    var rect = details.getBoundingClientRect();
    var amount = Math.min(rect.bottom - window.innerHeight, rect.top - topLimit);
    if (amount <= 0) return;
    var toPage = Math.min(amount, Math.max(0, info.getBoundingClientRect().top - topLimit));
    var toInfo = amount - toPage;
    if (toPage > 0) window.scrollBy(0, toPage);
    if (toInfo > 0) info.scrollBy(0, toInfo);
  }

  // o evento toggle não sobe na árvore, por isso apanha-se na fase de captura
  info.addEventListener('toggle', function(evt) {
    var details = evt.target;
    if (!desktop.matches || !details.open || !details.matches('details.disclosure')) return;
    var panel = details.querySelector('summary').nextElementSibling;
    if (!panel) return;
    var running = true;
    var started = performance.now();
    function frame() {
      reveal(details);
      // pára no fim da animação (ou ao fim de 1 s, se o transitionend não chegar)
      if (running && details.open && performance.now() - started < 1000) requestAnimationFrame(frame);
    }
    panel.addEventListener('transitionend', function onEnd(e) {
      if (e.target !== panel) return;
      panel.removeEventListener('transitionend', onEnd);
      running = false;
      // última correcção depois do handler do tema, que tira a altura fixa ao painel
      setTimeout(function() { reveal(details); }, 0);
    });
    requestAnimationFrame(frame);
  }, true);
})();
// #SACOOR#
